import { MessageConnection } from '../../models/chat.models';

export class LoadFiles {
    static readonly type = '[File] Load Files';
    constructor(
        public channelId: string,
        public limit?: number,
        public nextToken?: string,
    ) {}
}

export class LoadFilesSuccess {
    static readonly type = '[File] Load Files Success';
    constructor(
        public channelId: string,
        public connection: MessageConnection,
        public requestNextToken?: string,
    ) {}
}

export class LoadFilesError {
    static readonly type = '[File] Load Files Error';
    constructor(
        public channelId: string,
        public error: any,
    ) {}
}

// Load More (pagination)
export class LoadMoreFiles {
    static readonly type = '[File] Load More Files';
    constructor(
        public channelId: string,
        public limit?: number,
    ) {}
}

export class LoadMoreFilesSuccess {
    static readonly type = '[File] Load More Files Success';
    constructor(
        public channelId: string,
        public connection: MessageConnection,
        public requestNextToken?: string,
    ) {}
}

export class LoadMoreFilesError {
    static readonly type = '[File] Load More Files Error';
    constructor(
        public channelId: string,
        public error: any,
    ) {}
}

// Utility Actions
export class ClearFilesForChannel {
    static readonly type = '[File] Clear Files For Channel';
    constructor(public channelId: string) {}
}
